import { render, staticRenderFns } from "./commodityStatistics.vue?vue&type=template&id=6b84f522&scoped=true&"
import script from "./commodityStatistics.vue?vue&type=script&lang=js&"
export * from "./commodityStatistics.vue?vue&type=script&lang=js&"
import style0 from "./commodityStatistics.vue?vue&type=style&index=0&id=6b84f522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84f522",
  null
  
)

export default component.exports